import {
  setHtmlElementContent,
  obj2string,
  renderWebComponent,
  removeHtmlElement,
  scrollHtmlElementIntoView,
  addHtmlElementClass,
  EASE_IN_TRANSITION_TIME,
  addHtmlElementEventListener, setHtmlElementAttribute
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";
import {SubmissionListDeferredPaymentModalComponent} from "./SubmissionListDeferredPaymentModalComponent";


export class SubmissionListPaymentComponent extends HTMLElement {
  props = {};

  constructor(props) {
    super();
    this.attachShadow({ mode: 'open'});
    this.props = props;
    this.eventBus = EventBusComponent.getInstance();
    this.render();
  }


  connectedCallback() {
    // Se l'utente riprende a modificare la submission list quando ha già aperto il form di pagamento, annullo il
    // pagamento e segnalo l'evento agli altri web-components
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => {
      removeHtmlElement(this.shadowRoot, 'checkout-form');
      this.eventBus.publish("cancelled-submission-list-checkout", submissionList);
    });
    this.eventBus.subscribe('changed-middleman-price-rendering', (show) => {
      if (!show) {
        removeHtmlElement(this.shadowRoot, 'checkout-form');
        this.eventBus.publish("cancelled-submission-list-checkout", this.props.submissionList);
      }
    });

    addHtmlElementEventListener(this.shadowRoot, 'bank_transfer_payment_btn', 'mouseover', (e) => this.changeBankTransferIcon("/images/icons/white/bank_transfer_white.png"));
    addHtmlElementEventListener(this.shadowRoot, 'bank_transfer_payment_btn', 'mouseout', (e) => this.changeBankTransferIcon("/images/icons/bank_transfer.png"));
    addHtmlElementEventListener(this.shadowRoot, 'bank_transfer_payment_btn', 'click', () => SubmissionListDeferredPaymentModalComponent.getInstance(this.shadowRoot, this.props.submissionList, 'bank_transfer', this.props.currentUserGenerality));
    window.addEventListener('resize', () => this.handleWindowResize());
  }


  // Funzione che gestisce il resize della window
  handleWindowResize () {
    if (window.innerWidth <= 890 || (1200 <= window.innerWidth && window.innerWidth <= 1600))
      setHtmlElementContent(this.shadowRoot, 'bank_transfer_payment_label', I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.bank_transfer'));
  }


  // Funzione che cambia l'icona da renderizzare a video
  changeBankTransferIcon(path) {
    setHtmlElementAttribute(this.shadowRoot, 'bankTransferIcon', "src", path);
  }



  render() {
    const html = `
      <div id="checkout-form"
        class="row mb-5 pt-4 pb-3 px-sm-4 mt--15px-imp border-bottom-radius-20px border-left-solid border-right-solid border-bottom-solid d-flex justify-content-center shadow-on-left-bottom-right slide-animation-container submission-list-form-payment-section">
        <div class="col-12 col-md-6 col-xl-5 pt-3 text-center">
          ${
            this.props.submissionList.enable_payment ?
              `<h4>
                ${I18n.t('js.editSubmissionListPage.webComponent.checkout.text7')}
              </h4>
              <br/>`
            :
              ``
          }
          
          <div>
            ${
              this.props.submissionList.enable_payment && this.props.submissionList.grader_company.bank_transfer_payment_enabled ?
                `<button id="bank_transfer_payment_btn"
                    name="bank_transfer_payment_btn"
                    class="btn-aig-gradient-outline outline-none px-4rem-imp h-50px mb-3 w-100"
                >
                  <img src="/images/icons/bank_transfer.png" alt="" id="bankTransferIcon">
                  <span class="font-size-18px" 
                    id="bank_transfer_payment_label">
                    ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.bank_transfer_payment')}
                  </span>
                </button>`
              :   
                ``
            }
            
            <paypal-button-component
              props='${obj2string({
                amount: this.props.submissionList.amount,
                currency: 'EUR',
                locale: this.props.locale,
                submissionList: this.props.submissionList,
                disablePayment: !this.props.submissionList.enable_payment
              })}'
            >
            </paypal-button-component>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, submissionListsStyles]);

    this.handleWindowResize();
    setTimeout(() => addHtmlElementClass(this.shadowRoot, "checkout-form", "slide-down"), 1);
    setTimeout(() => scrollHtmlElementIntoView(this.shadowRoot, "checkout-form", false), EASE_IN_TRANSITION_TIME);
  }
}

window.customElements.define("submission-list-payment-component", SubmissionListPaymentComponent);